import React, { useState } from 'react';
function SharedGPAPlanner() {
    const [currentGPA, setCurrentGPA] = useState(0);
    const [targetGPA, setTargetGPA] = useState(0);
    const [currentCredits, setCurrentCredits] = useState(0);
    const [additionalCredits, setAdditionalCredits] = useState(0);
    const [showResult, setShowResult] = useState(false);
    const [error, setError] = useState(null);
    const calculateRequiredGPA = () => {
        const remainingCredits = currentCredits + additionalCredits;
        const requiredGPA = (targetGPA * remainingCredits - currentGPA * currentCredits) / additionalCredits;
        if (requiredGPA <= 4.0) {
            return (
                <div>
                    To achieve the target cumulative GPA of <strong>{targetGPA}</strong>, you must have a GPA of <strong>{requiredGPA.toFixed(3)}</strong> or higher for the next <strong>{additionalCredits}</strong> credits.
                </div>
            );
        } else {
            return (
                <div>
                    It is not possible to achieve the target cumulative GPA with the given credits and the current cumulative GPA.
                </div>
            );
        }
    };
    const handleCalculateClick = () => {
        setShowResult(true);
        setError(null);
    };
    return (
        <div>
            <div className="row">
                <div className="col-sm-12 col-md-7 calculatorStyle">
                    <div className="p-3 mb-2 bg-success text-white">
                        <h2 style={{ fontSize: '16px' }}>Cumulative GPA Planner</h2>
                    </div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                        <b><label htmlFor="currentGPA">Current Cumulative GPA:</label></b>
                        <input type="number" style={{ width: '75px' }} value={currentGPA} onChange={(e) => setCurrentGPA(parseFloat(e.target.value))} className="form-control" id="currentGPA" />
                    </div>
                    <div className="form-group d-flex align-items-center">
                        <b><label htmlFor="targetGPA">Target Cumulative GPA:</label></b>
                        <input type="number" style={{ width: '75px' }} value={targetGPA} onChange={(e) => setTargetGPA(parseFloat(e.target.value))} className="form-control" id="targetGPA" />
                    </div>
                    <div className="form-group d-flex align-items-center">
                        <b><label htmlFor="currentCredits">Completed Credits:</label></b>
                        <input type="number" style={{ width: '75px' }} value={currentCredits} onChange={(e) => setCurrentCredits(parseFloat(e.target.value))} className="form-control" id="currentCredits" />
                    </div>
                    <div className="form-group d-flex align-items-center">
                        <b><label htmlFor="additionalCredits">Planned Credits:</label></b>
                        <input type="number"
                            value={additionalCredits}
                            onChange={(e) => setAdditionalCredits(parseFloat(e.target.value))}
                            className="form-control"
                            style={{ width: '75px' }}
                            id="additionalCredits"
                        />
                    </div>
                    <button className="btn btn-success mt-3" onClick={handleCalculateClick}>Calculate</button>
                    <br />
                </div>
            </div>
            <br />
            <div className="row">
                <div className="col-sm-12 col-md-7">
                    {error && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly. </div>}
                    {showResult && (
                        <div style={{ fontSize: '16px' }} className="bg-light bg-gradient text-dark">
                            <div className="p-3 bg-success bg-gradient text-white">
                                <strong>Results</strong>
                            </div>
                            {calculateRequiredGPA()}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default SharedGPAPlanner;
